<template>
  <span class="logofont">boosh</span>
</template>

<script>
export default {
  name: "Logo",
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Righteous");

.logofont {
  font-family: 'Righteous', sans-serif;
}

</style>